import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { red } from "@mui/material/colors";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";

import { post } from "../../utils/io";
import PasswordVerification from "../Auth/PasswordVerification";

function VerifyUser() {
  const { hash } = useLocation();
  const history = useHistory();
  const theme = useTheme();

  const [isPasswordError, setIsPasswordError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalidToken, setIsInvalidToken] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [input, setInput] = useState({
    password: "",
    confirmPassword: "",
  });
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errMessage, setErrMessage] = useState("");

  const setPassword = (value) =>
    setInput((pre) => ({ ...pre, password: value }));

  const setConfirmPassword = (value) =>
    setInput((pre) => ({ ...pre, confirmPassword: value }));

  useEffect(() => {
    setIsLoading(true);

    async function tokenVerified() {
      const res = await post(`/users/invites/validate_token`, {
        confirmation_token: hash.slice(1),
      });
      if (res.status === 204) {
        setIsLoading(false);
        return;
      }
      setIsInvalidToken(true);
      setIsLoading(false);
    }
    tokenVerified();
  }, [history, hash]);

  const isDisableButton = () =>
    isRequesting ||
    !input.confirmPassword ||
    !input.password ||
    input.password !== input.confirmPassword ||
    isPasswordError;

  const onUpdateUser = async () => {
    const payload = {
      confirmation_token: hash.slice(1),
      password: input.password,
      first_name: firstName,
      last_name: lastName,
    };
    setIsRequesting(true);
    if (!firstName) return setErrMessage("First name is required");
    if (!lastName) return setErrMessage("Last name is required");
    setErrMessage("");
    const res = await post("/users/invites/accept", payload);
    setIsRequesting(false);
    if (res.status === 204) {
      return history.push("/");
    }
    return setErrMessage("Cannot update password");
  };

  return (
    <Grid
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      {isLoading && <CircularProgress />}
      {!isLoading && isInvalidToken && (
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #ccc",
            borderRadius: "4px",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4),
          }}
        >
          <h2>This invite is no longer valid</h2>
          <p>
            Either the invite has been completed or cancelled. Please contact a
            member of the organization.
          </p>
        </Box>
      )}
      {!isLoading && !isInvalidToken && (
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #ccc",
            borderRadius: "4px",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4),
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              maxWidth: 300,
            }}
          >
            <h3>Select a password</h3>
            <TextField
              value={firstName}
              variant="outlined"
              name="first_name"
              required
              label="First name"
              size="small"
              onChange={(e) => setFirstName(e.target.value)}
              sx={{
                margin: theme.spacing(1, 0),
                width: "100%",
              }}
            />
            <TextField
              value={lastName}
              variant="outlined"
              name="last_name"
              required
              label="Last Name"
              size="small"
              onChange={(e) => setLastName(e.target.value)}
              sx={{
                margin: theme.spacing(1, 0),
                width: "100%",
                marginBottom: 10,
              }}
            />
            <PasswordVerification
              password={input.password}
              setPassword={setPassword}
              confirmPassword={input.confirmPassword}
              setConfirmPassword={setConfirmPassword}
              setError={setIsPasswordError}
            />
            {errMessage && (
              <Typography
                variant="body2"
                sx={{
                  color: red[500],
                  fontStyle: "italic",
                  textAlign: "center",
                  marginTop: 0,
                }}
              >
                {errMessage}
              </Typography>
            )}
            <Button
              onClick={onUpdateUser}
              disabled={isDisableButton()}
              color="primary"
              variant="contained"
            >
              {isRequesting && (
                <CircularProgress size={16} sx={{ marginRight: 10 }} />
              )}{" "}
              Register
            </Button>
          </Box>
        </Box>
      )}
    </Grid>
  );
}

export default VerifyUser;
